var XPortal = XPortal || {};
XPortal.FilterCommon = {
    Filtering_EQ: 'Is equal to',
    Filtering_NEQ: 'Is not equal to'
};
XPortal.GridFiltering = (function () {
    var localizedMessages = { where: "Where", or: "Or", and: "And" };
    var self = {
        Filtering_EQ: 'Is equal to',
        Filtering_NEQ: 'Is not equal to',
        models: [],
        Operators: {
            values: [
                { value: "eq", name: XPortal.FilterCommon.Filtering_EQ, IsValueVisible: true },
                { value: "neq", name: XPortal.FilterCommon.Filtering_NEQ, IsValueVisible: true }
            ],
            string: [{
                value: "eq",
                name: XPortal.FilterCommon.Filtering_EQ,
                IsValueVisible: true
            },
            {
                value: "neq",
                name: XPortal.FilterCommon.Filtering_NEQ,
                IsValueVisible: true
            },
            {
                value: "startswith",
                name: 'Starts with',
                IsValueVisible: true
            },
            {
                value: "contains",
                name: 'Contains',
                IsValueVisible: true
            },
            {
                value: "doesnotcontain",
                name: 'Does not contain',
                IsValueVisible: true
            },
            {
                value: "endswith",
                name: 'Ends with',
                IsValueVisible: true
            },
            {
                value: "blank",
                name: 'Is empty',
                IsValueVisible: false
            },
            {
                value: "notblank",
                name: 'Is not empty',
                IsValueVisible: false
            }
            ],
            number: [{
                value: "eq",
                name: XPortal.FilterCommon.Filtering_EQ,
                IsValueVisible: true
            },
            {
                value: "neq",
                name: XPortal.FilterCommon.Filtering_NEQ,
                IsValueVisible: true
            },
            {
                value: "gte",
                name: 'Is greater than or equal to',
                IsValueVisible: true
            },
            {
                value: "gt",
                name: 'Is greater than',
                IsValueVisible: true
            },
            {
                value: "lte",
                name: 'Is less than or equal to',
                IsValueVisible: true
            },
            {
                value: "lt",
                name: 'Is less than',
                IsValueVisible: true
            },
            {
                value: "blank",
                name: 'Is null',
                IsValueVisible: false
            },
            {
                value: "notblank",
                name: 'Is not null',
                IsValueVisible: false
            }
            ],
            date: [{
                value: "eq",
                name: XPortal.FilterCommon.Filtering_EQ,
                IsValueVisible: true
            },
            {
                value: "neq",
                name: XPortal.FilterCommon.Filtering_NEQ,
                IsValueVisible: true
            },
            {
                value: "gte",
                name: 'Is after or equal to',
                IsValueVisible: true
            },
            {
                value: "gt",
                name: 'Is after',
                IsValueVisible: true
            },
            {
                value: "lte",
                name: 'Is before or equal to',
                IsValueVisible: true
            },
            {
                value: "lt",
                name: 'Is before',
                IsValueVisible: true
            },
            {
                value: "blank",
                name: 'Is empty',
                IsValueVisible: false

            },
            {
                value: "notblank",
                name: 'Is not empty',
                IsValueVisible: false
            },
            {
                value: "ltc",
                name: 'Is before current date',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "eqc",
                name: 'Is equals to current date',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "gtc",
                name: 'Is after current date',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "isgtedys",
                name: 'Is greater than(days)',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "isltedys",
                name: 'Is less than(days)',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "iseqldys",
                name: 'Is equals with(days)',
                IsPeriodic: true,
                IsValueVisible: true
            }
            ],
            datetime: [{
                value: "eq",
                name: XPortal.FilterCommon.Filtering_EQ
            },
            {
                value: "neq",
                name: XPortal.FilterCommon.Filtering_NEQ,
                IsValueVisible: true
            },
            {
                value: "gte",
                name: 'Is after or equal to',
                IsValueVisible: true
            },
            {
                value: "gt",
                name: 'Is after',
                IsValueVisible: true
            },
            {
                value: "lte",
                name: 'Is before or equal to',
                IsValueVisible: true
            },
            {
                value: "lt",
                name: 'Is before',
                IsValueVisible: true
            },
            {
                value: "blank",
                name: 'Is empty',
                IsValueVisible: false
            },
            {
                value: "notblank",
                name: 'Is not empty',
                IsValueVisible: false
            },
            {
                value: "ltc",
                name: 'Is before current date',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "eqc",
                name: 'Is equals to current date',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "gtc",
                name: 'Is after current date',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "isgtehrs",
                name: 'Is greater than(hours)',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "isltehrs",
                name: 'Is less than(hours)',
                IsPeriodic: true,
                IsValueVisible: true
            },
            {
                value: "iseqlhrs",
                name: 'Is equals with(hours)',
                IsPeriodic: true,
                IsValueVisible: true
            }],
            enums: {
                eq: XPortal.FilterCommon.Filtering_EQ,
                neq: XPortal.FilterCommon.Filtering_NEQ,
                isnull: 'Is null',
                isnotnull: 'Is not null'
            },
            boolean: [{
                value: "eq",
                name: XPortal.FilterCommon.Filtering_EQ,
                IsValueVisible: true
            },
            {
                value: "neq",
                name: XPortal.FilterCommon.Filtering_NEQ,
                IsValueVisible: true
            },
            {
                value: "isnull",
                name: "Is null",
                IsValueVisible: true
            },
            {
                value: "isnotnull",
                name: "Is not null",
                IsValueVisible: true
            }
            ],
            unknown: [{
                value: "eq",
                name: XPortal.FilterCommon.Filtering_EQ,
                IsValueVisible: true
            },
            {
                value: "neq",
                name: XPortal.FilterCommon.Filtering_NEQ,
                IsValueVisible: true
            }
            ]
        },

        // l10n
        LocalizeKeys: {},
        LocalizePreffix: "XPortal.Frontend.Filter.",
        LocalizationResult: null,
        _localizationPromise: null,

        conditionsDropDown: function (rowNumber, imessages) {
            var ilocalMsgs = (imessages || {}).filter || localizedMessages;
            if (rowNumber === 0) return [{ title: ilocalMsgs.where, conditionDropDown: "Where" }];
            else return [{ title: ilocalMsgs.and, conditionDropDown: "And" }, { title: ilocalMsgs.or, conditionDropDown: "Or" }];
        },
        roles: {
            'string': '',
            'number': 'numerictextbox',
            'date': 'datepicker',
            'datetime': 'datetimepicker'
        },
        classVal: {
            'string': 'k-textbox',
            'date': 'k-input',
            'datetime': 'k-input',
            'number': 'k-input'
        },
        AdditionalGridOperators: [
            {
                value: "dateToday",
                name: 'Today',
                IsValueVisible: false
            },
            {
                value: "dateCurrentWeek",
                name: 'Current week',
                IsValueVisible: false
            },
            {
                value: "dateCurrentMonth",
                name: 'Current month',
                IsValueVisible: false
            }],
        Init: function () {
            return new Promise((onOk) => {
                ensureLocalization().then(() => {
                    onOk();
                });
            })
        },
        MapFilterRow: function (options, cols) {
            localizedMessages = options.griddata ? options.griddata.options.messages.filter : { where: "Where", or: "Or", and: "And" };
            options = backwardComp(options, cols);
            var fieldName = options.row.Field ? options.row.Field.field : options.row.field;
            if (!fieldName) return;
            options.row.Field = cols.find(col => col.field.toLowerCase() === fieldName.toLowerCase() || col.field.toLowerCase() === XPortal.Grid.normalizeFieldPrefix + fieldName.toLowerCase());
            if (options.row.Field && options.row.Field.Format && options.row.Field.Format.indexOf("<a href") > -1) options.row.Field.Format = "";
            if (!options.row.Field && fieldName !== "___group___") console.log('there is no column with such name that is available. fname: ' + fieldName, cols);

            var isDateSpecific = ((options.row.Field || {}).type || (options.row.FieldType || "")).toLowerCase().indexOf("date") >= 0;
            options.row.additionalType = !isDateSpecific ? '' : options.row.additionalType || "date";
            options.row.conditions = options.row.conditions || options.conditions;

            var fieldWasChanged = !options.row.field || options.row.field.toLowerCase() !== fieldName.toLowerCase();
            options.row.field = fieldName;
            if (options.row.Field && options.row.field !== "___group___") {
                if (options.row.Field.type)
                    options.row.FieldType = options.row.Field.type;
                else if (options.types)
                    options.row.FieldType = options.types.find(ft => ft.Field === options.row.Field.field) ? options.types.find(ft => ft.Field === options.row.Field.field).Type : undefined;

                if (options.filters) options.row.conditionDropDown = (options.filters.indexOf(options.row) === 0) ? localizedMessages.and : (options.conditionDropDown === undefined ? localizedMessages.or : options.conditionDropDown);

                options.row.FieldType = XPortal.EntityFilterPicker.MapFieldType(options.row.FieldType);
                options.row.operators = XPortal.GridFiltering.Operators[options.row.FieldType];
                if (typeof options.row.operators === typeof undefined) {
                    var iconsole = window.console;
                    options.row.operators = XPortal.GridFiltering.Operators["unknown"];
                    if (iconsole && iconsole.warn) console.warn("can't obtain operators for entity type.has been used -default", options.row.FieldType);
                }
                options.row.IsBoolean = options.row.FieldType === "boolean" ? true : false;
                //processing date filters
                if (isDateSpecific) {
                    if (options.row.additionalType === "period") {
                        var addOp = options.row.additionalType ? (options.row.advancedOperator ? options.row.advancedOperator : options.row.value) : options.row.value;
                        var additionalOp = XPortal.GridFiltering.AdditionalGridOperators.find(op => op.value === addOp);
                        if (additionalOp) {
                            options.row.additionalType = "period";
                            options.row.advancedOperator = additionalOp.value;
                        }
                    }

                    if (options.row.additionalType === "date") {
                        options.row.advancedOperators = null;
                        options.row.advancedOperator = null;
                    } else {
                        options.row.value = "";
                        options.row.advancedOperators = self.AdditionalGridOperators;
                        options.row.advancedOperator = options.row.advancedOperator ? options.row.advancedOperator : self.AdditionalGridOperators[0].value;
                        if (options.row.advancedOperator) options.row.advancedOperatorName = self.AdditionalGridOperators.find(item => item.value == options.row.advancedOperator).name;
                    }
                }
                options.row.Initialized = options.row.FieldType != null;
                options.row.role = XPortal.GridFiltering.roles[options.row.FieldType];
                options.row.classVal = XPortal.GridFiltering.classVal[options.row.FieldType];
                if (fieldWasChanged) {
                    if (options.row.operators && options.row.operators.length > 0) options.row.operator = options.row.operators[0].value;
                    options.row.value = '';
                }
                options.row.IsPeriodic = options.row.operator ? ((options.row.operators.find(op => op.value === options.row.operator) || {}).IsPeriodic ? true : false) : false;
                if (options.row.IsPeriodic) 
                    options.row.additionalType = "";//null value setup to clean up previously setuped value
                else 
                    options.row.IsPeriodic = options.row.additionalType == "period";
                if (!options.row.IsPeriodicNotification && ((options.row.FieldType === "date" || options.row.FieldType === "datetime") && typeof options.row.value === typeof String())) {

                    var tmpDateVal = options.row.value;
                    if (tmpDateVal && tmpDateVal.length > 0)
                        tmpDateVal = XPortal.Utils.TransformDateTime(tmpDateVal, (options.row.FieldType === "date" ? "YYYY-MM-DD" : null), true, false, false, false);

                    options.row.value = (typeof tmpDateVal.toDate === "function" ? tmpDateVal.toDate() : tmpDateVal);
                }
            }
            else if (options.row.field == "___group___") {
                options.row.FieldType = "string";
                options.row.conditionDropDown = options.conditionDropDown == null ? localizedMessages.or : options.conditionDropDown;
                if (options.row.isFirst) options.row.conditionDropDown = localizedMessages.where;
                options.row.operators = [];
                options.row.operator = null;
                options.row.IsBoolean = false;
                options.row.classVal = XPortal.GridFiltering.classVal[options.row.FieldType];
                options.row.Field = { field: "___group___", format: "", title: "group", type: "string" };
                options.row.Initialized = true;
            }
            options.row.IsValueVisible = (options.row.operator && (options.row.operator === "blank" || options.row.operator === "notblank")) ? false : true;
            if (options.row.operators && options.row.operator) {
                let operator = options.row.operators.find(op => op.value === options.row.operator);
                if (operator && operator.hasOwnProperty("IsValueVisible"))
                    options.row.IsValueVisible = operator.IsValueVisible;
                else
                    options.row.IsValueVisible = true;
            }
            
            options.row.pcolumns = function () {
                var foptions = (!options.griddata ? {} : options.griddata.dataSource.options).onShowFilterColumns;
                if (foptions) return foptions(cols);
                return cols;
            };
            options.row.isLastIn = function (filterRow) {
                if (!filterRow) return false;
                var isGroupCheck = filterRow.Field.field === "___group___";
                var prnt = filterRow.parent ? filterRow.parent() : null;
                if (!prnt) return false;
                if (prnt.length === 1) return true;//for any case
                var curIndex = prnt.indexOf(filterRow);
                for (var i = curIndex + 1; i < prnt.length; i++) {
                    if (isGroupCheck) {
                        if (prnt[i].Field.field === "___group___") return false;
                    } else
                        return prnt[i].Field.field === "___group___";
                }
                return true;
            };
            options.row.getColValues = function () {
                var fval = ((this || {}).Field || {}).values;
                return fval;
            };
            if (options.row.isFirst == null) options.row.isFirst = false;
            options.row.getConditions = function () {
                var xc = this.get("conditions");
                return xc;
            };
            options.row.isConditionVisible = function (itemsToShow) {
                var xc = this.get("conditions") || [];
                var maxItems = Math.abs(itemsToShow);
                var shouldShow = itemsToShow > 0;//in case of less then zero - should be hidden
                var result = xc.length > maxItems ? shouldShow : (!shouldShow);
                return result;
            };
            return options.row;
        },
        TogleDisplayFiltersPane: function (options) {
            if (!$(options.element).hasClass("filter-list-buttons"))
                options.element = $(options.element).find(".filter-list-buttons");
            if (options.filtersPresent) {
                $(options.element).addClass("display-filters");
                $(options.element).find("#resetFilters").removeClass("d-none");
                $(options.element).find("#submitFilters").removeClass("d-none");
            }
            else {
                $(options.element).removeClass("display-filters");
                $(options.element).find("#resetFilters").addClass("d-none");
                $(options.element).find("#submitFilters").addClass("d-none");
            }
        },
        BindFilters: function (grid, options, isLoadPage) {
            self.Init().then(() => {
                var kgridData = grid.data("kendoGrid");
                var gridId = kgridData.options.pageData.nodeId;
                var modelActions = XPortal.GridActions.actionmodels[gridId];
                var onModelExist = function () {
                    var result = self.getOrInitFilteringModel(grid, options, isLoadPage) || { filters: [] };
                    XPortal.GridFiltering.TogleDisplayFiltersPane({
                        element: options.element,
                        filtersPresent: result.filters.length > 0
                    });

                    self.BindKendoFilters(result, gridId);

                    var isPinnedState = kgridData.options.pinnedState || false;
                    var showStaticFilters = grid.attr("data-show-static-filters");
                    self.VisualizeFilterBlock(isPinnedState, showStaticFilters, isLoadPage, gridId);
                    $("li", options.element).off("click").on("click", function (e) {
                        e.stopPropagation();
                    });
                    if (!isLoadPage) self.SetFilterPopupPositionEvents(options.element);

                    return result;
                };
                if (modelActions != null) return onModelExist();
                XPortal.Utils.waitFor(function () {
                    modelActions = XPortal.GridActions.actionmodels[gridId];
                    if (modelActions == null) return false;
                    onModelExist();
                    return true;
                }, XPortal.Utils.waitFor, 100);
            });
        },
        getOrInitFilteringModel: function (grid, options, isLoadPage) {
            var kgridData = grid.data("kendoGrid");
            var gridId = "";
            var localizedMessages = null;
            var gridFilterModel = null;
            if(!kgridData) return;
            XPortal.Utils.waitFor(function () {
                if (!kgridData.options) return true;
                gridId = kgridData.options.pageData.nodeId;
                localizedMessages = kgridData.options.messages.filter;
                gridFilterModel = !kgridData || !kgridData.options ? null : kgridData.options.gridFilterViewModel;
                if (gridFilterModel != null) return true;//it is already initialized
                return false;
            }, XPortal.Utils.waitFor, 100);

            var resultFilters = [];
            if (!kgridData.options.commands.filter || grid.closest(".grid-parent").find("[data-action=Filter]").length == 0) {//filtering is turned off
                XPortal.GridFiltering.HideStaticArea(kgridData.options.pageData.nodeId);
                return;
            }
            var fieldAndColumns = kgridData.options.filterFieldAndColumns = getFieldsAndColumns(kgridData);
            getGridFilters(kgridData, fieldAndColumns, resultFilters) || [];


            if (gridFilterModel) {
                resultFilters = getGridFilters(kgridData, fieldAndColumns, kgridData.dataSource.filter() ? [] : gridFilterModel.filters) || [];
            }
            gridFilterModel = new kendo.observable({
                columns: fieldAndColumns.columns,
                filters: resultFilters,
                deleteRow: function (e) {
                    if (!$(e.target).hasClass("close")) return;
                    var uid = e.currentTarget.dataset["uid"];
                    var filters = XPortal.GridActions.actionmodels[gridId].filters;
                    filters = XPortal.GridFiltering.DeleteFilter(filters, uid);
                    if (filters.length < 1) $(options.element).toggleClass('open');
                    else XPortal.GridFiltering.TogleDisplayFiltersPane({ element: options.element, filtersPresent: filters.length > 0 });
                    XPortal.GridFiltering.ApplyFilter({ filters: filters, kgrid: kgridData });
                },
                conditions: self.conditionsDropDown(1, localizedMessages),
                addFilter: function (e) {
                    var uid = e.currentTarget.dataset["uid"];
                    var mappedFilter = self.AddDefaultFilterToGroup(kgridData, gridFilterModel, fieldAndColumns);
                    if (mappedFilter) {
                        if (gridFilterModel.filters.length === 0) { //add default value
                            gridFilterModel.filters.push(mappedFilter);
                        }
                        else
                            self.InsertFilter(gridFilterModel, uid, mappedFilter, localizedMessages);
                    }
                    bindFilterArea(options.element, gridFilterModel);
                    if (gridFilterModel.filters.length === 1) {
                        gridFilterModel.filters[0].conditionDropDown = "Where";
                        self.TogleDisplayFiltersPane({ element: options.element, filtersPresent: true });
                    }
                    XPortal.Grid.ResizeGrid(kgridData.element);
                }
            });
            if (gridFilterModel.filters.length < 1)
                addGroupFilter(kgridData, gridFilterModel, fieldAndColumns);

            if (XPortal.GridActions.actionmodels[gridId]) XPortal.GridActions.actionmodels[gridId].set("filters", gridFilterModel.filters);

            gridFilterModel.bind("change", function (e) {
                if (e.items.length > 0) {
                    var changedUid = e.items[0].uid;
                    if (e.action === "itemchange") {

                        XPortal.GridFiltering.MapFilterRow({
                            griddata: kgridData, row: e.sender.filters.find(f => f.uid === changedUid), types: fieldAndColumns.fields, filters: e.sender.filters,
                            conditionDropDown: e.items[0].conditionDropDown.conditionDropDown === undefined ? e.items[0].conditionDropDown : e.items[0].conditionDropDown.conditionDropDown
                        }, gridFilterModel.columns);
                        let gridId = kgridData.options.pageData.nodeId;
                        XPortal.GridFiltering.BindKendoFilters(gridFilterModel, gridId);
                        XPortal.GridActions.actionmodels[gridId].set("filters", gridFilterModel.filters);
                    }
                }
                XPortal.GridActions.actionmodels[gridId].set("filtered", gridFilterModel.filters.length > 0);
            });

            self.AddKeyboardHandlers({ element: options.element, model: gridFilterModel, griddata: kgridData });

            $("#resetFilters", options.element).off("click").on("click", function (e) { e.preventDefault(); self.onResetFilters(e, kgridData, options); });
            $("#addGroups", options.element).off("click").on("click", function (e) { e.preventDefault(); self.onAddFilterGroup(e, kgridData, options); });
            $("#submitFilters", options.element).off("click").on("click", function (e) { e.preventDefault(); self.onSubmitFilters(e, kgridData, options); });
            $("#closeFilter", options.element).off("click").on("click", function (e) { e.preventDefault(); self.onCloseFilter(e, kgridData, options); });

            grid.closest('.grid-parent').kendoTooltip({
                show: function (e) {
                    this.popup.element.addClass('grid-tooltip');
                },
                filter: '.unpinned-icon button',
                position: 'top',
                width: 150,
                content: function (e) {
                    return $(e.target).find('.unpinned-icon-tooltip-text').html();
                }
            });

            let tabSelector = "#entity-grid-" + gridId;
            let $tab = $(tabSelector);
            if ($tab.length > 0) {
                var $unpinnedIcon = $tab.closest(".grid-parent").find(".unpinned-icon");
                $unpinnedIcon.off("click").on("click", { kgridData: kgridData, gridFilterModel: gridFilterModel, grid: grid }, self.hadlePinnBtn);
            }
            else {
                document.querySelectorAll('.unpinned-icon').forEach(function (btn, index) {
                    $(btn).off("click").on("click", { kgridData: kgridData, gridFilterModel: gridFilterModel, grid: grid }, self.hadlePinnBtn);
                });
            }
            // $(document).on('mouseover', '.add-filter-button', function (e) {
            //     $(".add-filter-button").focus();
            // });
            // $(document).on('mouseover', '.apply-filter-button', function (e) {
            //     $(".apply-filter-button").focus();
            // });

            if (gridFilterModel.filters && gridFilterModel.filters.length > 0) gridFilterModel.filters[0].conditions = self.conditionsDropDown(0, localizedMessages);
            gridFilterModel.filters = self.MarkAsFirstOperatorInGroup(gridFilterModel.filters);

            kgridData.options.gridFilterViewModel = gridFilterModel;
            return gridFilterModel;
        },
        onResetFilters: function (e, kgridData, options) {
            var gridId = kgridData.options.pageData.nodeId;
            XPortal.GridActions.actionmodels[gridId].set("filters", []);
            var filters = XPortal.GridActions.actionmodels[gridId].filters;
            options.element.toggleClass('open');
            XPortal.GridFiltering.ApplyFilter({
                filters: filters,
                kgrid: kgridData
            });
        },
        onCloseFilter: function (e, kgridData) {
            $(e.target).closest(".filters-list-wrapper.static").removeClass("open");
            XPortal.Grid.ResizeGrid(kgridData.element);
        },
        onAddFilterGroup: function (e, kgridData, options) {
            var gridFilterModel = kgridData.options.gridFilterViewModel;
            var fieldsAndColumns = kgridData.options.filterFieldAndColumns;
            var lastFilter = gridFilterModel.filters[gridFilterModel.filters.length - 1];
            if (gridFilterModel.filters && gridFilterModel.filters.length > 0 && lastFilter.additionalType == "group") return;
            addGroupFilter(kgridData, gridFilterModel, fieldsAndColumns);
            bindFilterArea(options.element, gridFilterModel);
            XPortal.Grid.ResizeGrid(kgridData.element);
        },
        onSubmitFilters: function (e, kgridData, options) {
            var gridId = kgridData.options.pageData.nodeId;
            var filters = XPortal.GridActions.actionmodels[gridId].filters;
            XPortal.GridFiltering.ApplyFilter({
                filters: filters,
                kgrid: kgridData
            });
        },
        hadlePinnBtn: function (event) {
            $('.k-tooltip').hide();
            var staticArea;
            var actionArea;
            var $parent = $(event.data.grid).closest(".grid-parent");
            if ($parent) {
                staticArea = $parent.find(".filters-list-wrapper.static");
                actionArea = $parent.find(".desktop-inline .filters-list-wrapper.action");
            }
            var options = event.data.kgridData.options;
            if ($(event.target).hasClass("action")) {
                options.pinnedState = true;
                actionArea.removeClass("open");
                bindFilterArea(staticArea, event.data.gridFilterModel);
                XPortal.GridFiltering.TogleDisplayFiltersPane({
                    element: staticArea,
                    filtersPresent: true
                });
            }
            else if ($(event.target).hasClass("static")) {
                options.pinnedState = false;
                staticArea.removeClass("open");
                staticArea.hide();
                XPortal.GridActions.actionmodels[options.pageData.nodeId].set("filterOpen", false);
                if ($(event.data.grid).attr("data-show-static-filters") === "True") {
                    $(event.data.grid).attr("data-show-static-filters", false);
                    self.BindFilters(event.data.grid, { element: actionArea }, false);
                } else {
                    bindFilterArea(actionArea, event.data.gridFilterModel);
                }

                self.OpenFilterArea(actionArea);
                actionArea.show();
                event.stopPropagation();
                XPortal.GridFiltering.TogleDisplayFiltersPane({
                    element: actionArea,
                    filtersPresent: true
                });
            }
            XPortal.Grid.ResizeGrid(event.data.grid);
        },
        collectionHas: function (a, b) { //helper function (see below)
            for (var i = 0, len = a.length; i < len; i++) {
                if (a[i] == b) return true;
            }
            return false;
        },
        findParentBySelector: function (elm, selector) {
            var all = document.querySelectorAll(selector);
            var cur = elm.parentNode;
            while (cur && !self.collectionHas(all, cur)) { //keep going up until you find a match
                cur = cur.parentNode; //go up
            }
            return cur; //will return null if not found
        },
        AddFirstFilter: function (localizedMessages) {
            var groupFilter = {
                Field: {
                    field: "___group___",
                    format: "",
                    title: "group",
                    type: "string"
                },
                operator: localizedMessages.where,
                IsValueVisible: false,
                Initialized: false,
                IsPeriodic: false,
                conditionDropDown: localizedMessages.where,
                conditions: self.conditionsDropDown(0, localizedMessages),
                field: "___group___",
                isFirst: true
            };
            return groupFilter;
        },
        DeleteFilter: function (filters, uid) {
            var itemIndex = filters.map(f => f.uid).indexOf(uid);
            var item = filters[itemIndex];
            if (item.field == "___group___") {
                var lastRecorsIndex = itemIndex + 1;
                for (var i = itemIndex; i < filters.length; i++) {
                    if (i + 1 == filters.length) break;
                    var deleteItem = filters[i + 1];
                    if (deleteItem.field != "___group___") {
                        lastRecorsIndex++;
                    }
                    else if (deleteItem.field == "___group___") {
                        break;
                    }
                }
                filters.splice(itemIndex, lastRecorsIndex - itemIndex);
            }
            else if (itemIndex > -1) {
                let ni = null;
                let pi = null;
                if (filters.length > itemIndex + 1) ni = filters[itemIndex + 1];
                if (itemIndex != 0) pi = filters[itemIndex - 1];
                if ((pi != null && pi.field == "___group___") && (ni == null || ni.field == "___group___"))
                    filters.splice(itemIndex - 1, 2);
                else
                    filters.splice(itemIndex, 1);
            }
            if (filters.length == 1 && filters[0].field == "___group___") return [];
            return filters;
        },
        InsertFilter: function (gridFilterModel, uid, item, localizedMessages) {
            let filters = gridFilterModel.filters;
            var item = item || new kendo.data.ObservableObject({
                Field: null,
                field: "",
                Initialized: false,
                conditions: self.conditionsDropDown(filters.length, localizedMessages),
                conditionDropDown: localizedMessages.and
            });
            var itemIndex = filters.map(f => f.uid).indexOf(uid);
            var lastRecorsIndex = itemIndex + 1;
            for (var i = lastRecorsIndex; i < filters.length; i++) {
                if (i == filters.length) break;
                var nextItem = filters[i];
                if (nextItem.field != "___group___") {
                    lastRecorsIndex++;
                }
                else if (nextItem.field == "___group___") {
                    break;
                }
            }

            if (lastRecorsIndex > 0 && filters[lastRecorsIndex - 1].field == "___group___") item.hideCondition = true;
            gridFilterModel.filters.splice(lastRecorsIndex, 0, item);
            return gridFilterModel;
        },
        VisualizeFilterBlock: function (isPinnedState, showStaticFilters, isLoadPage, gridId) {
            if (isPinnedState) XPortal.GridFiltering.ShowStaticArea(gridId);
            else {
                if (showStaticFilters == "True") XPortal.GridFiltering.ShowStaticArea(gridId);
                else XPortal.GridFiltering.ShowActionArea(isLoadPage, gridId);
            }
        },
        ShowActionArea: function (isLoadPage, gridId) {
            XPortal.GridFiltering.HideStaticArea(gridId);
            let tabSelector = "#entity-grid-" + gridId;
            let $tab = $(tabSelector);
            let actionSelector = ".filters-list-wrapper.action";
            if ($tab.length > 0) {
                $tab.closest(".grid-parent").find(actionSelector).show();
            }
            if (isLoadPage == false) {
                if ($tab.length > 0) {
                    self.OpenFilterArea($tab.closest(".grid-parent").find(actionSelector));
                }
            }
        },
        ShowStaticArea: function (gridId) {
            let tabSelector = "#entity-grid-" + gridId;
            let $tab = $(tabSelector);
            let staticSelector = ".filters-list-wrapper.static";
            let actionSelector = ".filters-list-wrapper.action";
            if ($tab.length > 0) {
                let $parent = $tab.closest(".grid-parent");
                let $staticFilter = $parent.find(staticSelector);
                self.OpenFilterArea($staticFilter);
                let $actionFilter = $parent.find(actionSelector);
                $actionFilter.hide();
                $actionFilter.removeClass("open");
            }
        },
        HideStaticArea: function (gridId) {
            let tabSelector = "#entity-grid-" + gridId;
            let $tab = $(tabSelector);
            let staticSelector = ".filters-list-wrapper.static";
            if ($tab.length > 0) {
                let $staticFilter = $tab.closest(".grid-parent").find(staticSelector);
                $staticFilter.hide();
                $staticFilter.removeClass("open");
            }
        },
        BindKendoFilters: function (gridFilterModel, gridId) {
            var staticArea;
            var actionArea;
            let tabSelector = "#entity-grid-" + gridId;
            let $tab = $(tabSelector);
            if ($tab.length > 0) {
                var $parent = $tab.closest(".grid-parent");
                staticArea = $parent.find(".filters-list-wrapper.static");
                actionArea = $parent.find(".desktop-inline .filters-list-wrapper.action");
            }

            bindFilterArea(staticArea, gridFilterModel);
            bindFilterArea(actionArea, gridFilterModel);
        },
        OpenFilterArea: function (area) {
            var $area = area ? $(area) : null;
            if (!$area || !$area.length) return;
            ensureFilterAreaBound($area);
            $area.addClass("open");
        },
        AddDefaultFilterToGroup: function (kgridData, gridFilterModel, fieldAndColumns) {
            var localizedMessages = kgridData.options.messages.filter;
            var gridColumns = fieldAndColumns.columns;
            if (!gridColumns || !gridColumns.length) return;
            const field = { field: gridColumns[0].field };
            const mappedFilter = self.MapFilterRow({
                griddata: kgridData, row: field, types: fieldAndColumns.fields, filters: [field], conditions: self.conditionsDropDown(gridFilterModel.filters.length, localizedMessages)
            }, fieldAndColumns.columns);
            if (mappedFilter.operators && mappedFilter.operators.length > 0) {
                mappedFilter.operator = mappedFilter.operators[0].value;
            }
            return mappedFilter;
        },
        MarkAsFirstOperatorInGroup: function (filters) {
            if (!filters) return [];
            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                var nextIndex = i + 1;
                if (filter.field == "___group___" && nextIndex < filters.length) {
                    filters[nextIndex].hideCondition = true;
                }
            }
            return filters;
        },
        AddKeyboardHandlers: function (options) {
            $(options.element).off("keydown").on("keydown", ".filter-line-input > input:last", function (e) {
                if ((e.keyCode || e.which) === 13) {
                    var lastFilter = options.model.filters[options.model.filters.length - 1];
                    if (e.currentTarget.dataset["bind"].indexOf("value" > -1)) {
                        lastFilter.value = e.currentTarget.value;
                    }
                    XPortal.GridFiltering.ApplyFilter({
                        filters: options.model.filters,
                        kgrid: options.griddata
                    });
                    options.element.toggleClass('open');
                }
            });
        },
        ProcessDateFilter: function (f) {
            if (!f.additionalType || f.additionalType !== "period") return null;
            var resultFilter = { field: f.field, operator: f.operator, value: f.value, additionalType: "period" };
            // "eq" - Equals,"neq" - Not Equals, "gte" - Is after or equal to, "gt" - Is after , "lte" - Is before or equal to , "lt" - Is before
            if (f.value !== "dateCurrentWeek" && f.value !== "dateCurrentMonth") return resultFilter;

            resultFilter.oerator = "";
            var periodStartFilter = { value: f.value + "Start", field: f.field };
            var periodEndFilter = { value: f.value + "End", field: f.field };
            if (f.operator === "eq") {
                periodStartFilter.operator = "gte";
                periodEndFilter.operator = "lte";
                resultFilter.logic = "and";
                resultFilter.filters = [periodStartFilter, periodEndFilter];
            } else if (f.operator === "neq") {
                periodStartFilter.operator = "lt";
                periodEndFilter.operator = "gt";
                resultFilter.logic = "and";
                resultFilter.filters = [periodStartFilter, periodEndFilter];
            } else if (f.operator === "gt" || f.operator === "gte") {
                periodEndFilter.operator = f.operator;
                resultFilter.filters = [periodEndFilter];
            } else if (f.operator === "lte" || f.operator === "lt") {
                periodStartFilter.operator = f.operator;
                resultFilter.filters = [periodStartFilter];
            }
            return resultFilter;
        },
        ApplyFilter: function (options) {
            let filtersToApply = [];
            let gridId = options.kgrid.options.pageData.nodeId;
            options.filters.forEach((f) => {
                var operator = f.operators ? f.operators.find(op => op.value === f.operator) : null;
                if (f.additionalType && f.additionalType === "period") {
                    f.value = f.advancedOperator;
                    f = self.ProcessDateFilter(f);
                    if (f) filtersToApply.push(f);
                } else if (f.field && operator && (typeof f.value !== typeof undefined || !operator.IsValueVisible)) {
                    if (f.field.indexOf(XPortal.Grid.normalizeFieldPrefix) === 0) f.field = f.field.slice(XPortal.Grid.normalizeFieldPrefix.length);
                    filtersToApply.push({
                        field: f.field,
                        additionalType: f.additionalType ? f.additionalType : undefined,
                        operator: typeof f.operator.value === typeof undefined ? f.operator : f.operator.value,
                        value: !operator.IsValueVisible ? undefined : f.value,
                        logic: f.conditionDropDown
                    });
                } else if (f.field == "___group___") {
                    filtersToApply.push({
                        field: f.field,
                        additionalType: "group",
                        logic: f.conditionDropDown
                    });
                }
            });
            XPortal.GridActions.actionmodels[gridId].set("filtered", filtersToApply.length > 0);
            const cleanedFilters = filtersToApply.filter((filter, index, arr) => {
                if (filter.field !== '___group___') {
                    return true;
                }

                const nextItem = arr[index + 1];
                return nextItem && nextItem.field !== '___group___';
            });
            options.kgrid.dataSource.filter({
                filters: cleanedFilters,
                logic: "and"
            });
        },
        FilterPopupPositionTimeout: null,
        SetFilterPopupPositionEvents: function (element) {
            XPortal.GridFiltering.SetFilterPopupPosition(element);

            $(window).off('resize.filterposition orientationchange.filterposition').on('resize.filterposition orientationchange.filterposition', function () {
                clearTimeout(XPortal.GridFiltering.FilterPopupPositionTimeout);
                XPortal.GridFiltering.FilterPopupPositionTimeout = setTimeout(function () {
                    XPortal.GridFiltering.SetFilterPopupPosition(element);
                }, 150);
            });
        },
        SetFilterPopupPosition: function (element) {
            element = element.filter(':visible');
            var $wrapper = element.closest('li.dropdown-item');
            var $gridWrp = element.closest('.grid-parent');
            var lineLeftPosition = $gridWrp.find('.grid-action-header').offset();
            var lineLeftPosition = lineLeftPosition ? lineLeftPosition.left : 0;
            var elementLeftPosition = $wrapper.offset();
            elementLeftPosition = elementLeftPosition ? elementLeftPosition.left : 0;
            if (elementLeftPosition + element.outerWidth() > $(window).width()) {
                var marginLeft = - (elementLeftPosition - lineLeftPosition - 10);
                var width = $(window).width() - elementLeftPosition - marginLeft - 20;
                element.css(
                    {
                        'margin-left': marginLeft,
                        'width': width < 880 ? width : 880
                    });
            }
            else {
                element.css(
                    {
                        'margin-left': 0,
                        'width': 880
                    });
            }

            XPortal.DropdownBtns.openDotsIfPanelInside(element);
        },
        CreateFilter: function (filterObj, kgridData) {
            /*field/operator/value/logic*/
            var fieldsAndColumns = kgridData.options.filterFieldAndColumns;
            let mappedFilter = XPortal.GridFiltering.MapFilterRow({
                griddata: kgridData, row: filterObj, types: fieldsAndColumns.fields, conditionDropDown: filterObj.logic
            }, fieldsAndColumns.columns);
            return mappedFilter;
        },
        Localize: function () {
            var startKey = self.LocalizePreffix;
            for (var i in XPortal.FilterCommon)
                XPortal.FilterCommon[i] = XPortal.Localization.GetCachedString(startKey + i, XPortal.FilterCommon[i]);
            for (var i in localizedMessages)
                localizedMessages[i] = XPortal.Localization.GetCachedString(startKey + i, localizedMessages[i]);
            for (var i in self)
                if (_.isString(self[i]))
                    self[i] = XPortal.Localization.GetCachedString(startKey + i, self[i]);

            for (var i in self.Operators) {
                var xoperator = self.Operators[i];
                self._localizeOperator(xoperator, i + ".", startKey + "Operators.");
            }
            self._localizeOperator(self.AdditionalGridOperators, "AdditionalGridOperators.", startKey);
            return true;
        },
        _localizeOperator: function (xoperator, xname, startKey) {
            var startConcrete = startKey + xname;
            if (_.isArray(xoperator))
                xoperator.forEach(function (xi, xii) {
                    if (!xi.value) return;
                    var xiLname = XPortal.Localization.GetCachedString(startConcrete + xi.value, null);
                    if (!xiLname) xiLname = XPortal.Localization.GetCachedString(startKey + xi.value, xi.name);
                    xi.name = xiLname;
                });
        }
    };
    function getFieldsAndColumns(kgridData) {
        var bluredFields = [];
        var fieldTypes = kgridData.dataSource.options.fields.map(function (fld) {
            return { Field: fld.field, Type: fld.attributes["data-ctype"] };
        }).filter(item => item.Type !== "calendarcolumn" && !(bluredFields.find(xf => item.Field && xf == item.Field.toLowerCase())));
        fieldTypes.push({ field: "___group___", Type: "string" });
        if (kgridData.dataSource.options.extratypes)
            _.each(kgridData.dataSource.options.extratypes, function (etx) { fieldTypes.push(etx); });
        var mColumns = kgridData.columns.map(function (col) {
            return {
                field: col.field,
                title: col.headerAttributes["title"] ? col.headerAttributes["title"] : col.field,
                format: col.attributes["data-ctype"] === "date" ? col.format : "",
                type: col.attributes["data-ctype"]
            };
        }).filter(function (col) {
            return col.title && col.field && col.field !== "selectable" && col.type !== "calendarcolumn" && !(bluredFields.find(xf => xf == col.field.toLowerCase()));
        });
        var gridColumns = [];
        if (kgridData.dataSource.options.extracolumns) {
            _.each(kgridData.dataSource.options.extracolumns, function (etx) { gridColumns.push(etx); });
            _.each(mColumns, function (etx) { gridColumns.push(etx); });
        } else {
            gridColumns = mColumns;
        }
        return { fields: fieldTypes, columns: gridColumns };
    };
    function getGridFilters(kgridData, fieldsAndColumns, resultFilters) {
        var filters = [];
        var localizedMessages = kgridData.options.messages.filter;
        var dsfilters = kgridData.dataSource.filter();
        if (dsfilters && dsfilters.filters.length > 0) {
            var firstFilter = dsfilters.filters[0];
            if (firstFilter.field != "___group___") {
                let filter = self.AddFirstFilter(localizedMessages);
                let mappedFilter = XPortal.GridFiltering.MapFilterRow({
                    griddata: kgridData, row: filter, types: fieldsAndColumns.fields, conditionDropDown: filter.logic
                }, fieldsAndColumns.columns);
                filters.push(mappedFilter);
            }
            dsfilters.filters.forEach(function (f, _i, arr) {
                f.field && filters.push(XPortal.GridFiltering.MapFilterRow({
                    griddata: kgridData, row: f, types: fieldsAndColumns.fields, filters: arr, conditionDropDown: f.logic
                }, fieldsAndColumns.columns));
            });

            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                if (filter.FieldType) {
                    if (i == 0) {
                        filter.isFirst = true;
                        filter.conditionDropDown = localizedMessages.where;
                    }
                    if (filter.field == "___group___") filter.Initialized = false;
                    resultFilters.push(filter);
                }
            }
        };

        if (resultFilters.length > 0 && resultFilters.filter(item => item.field != "___group___").length === 0) { //add default value
            const field = { field: fieldsAndColumns.columns.filter(function (col) { return col.field != "selectable"; })[0].field };
            const mappedFilter = XPortal.GridFiltering.MapFilterRow({
                griddata: kgridData, row: field, types: fieldsAndColumns.fields, filters: [field]
            }, fieldsAndColumns.columns);
            if (mappedFilter.operators && mappedFilter.operators.length > 0) {
                mappedFilter.operator = mappedFilter.operators[0].value;
            }
            mappedFilter.conditions = self.conditionsDropDown(resultFilters.length, localizedMessages);
            mappedFilter.conditionDropDown = localizedMessages.and;
            resultFilters.push(mappedFilter);
        };
        resultFilters.forEach(function (filter) {
            if (filter.operators) {
                var operator = filter.operators.find(itm => itm.value == filter.operator);
                if (operator) filter.operatorName = operator.name;
            }
        });
        return resultFilters;
    }
    function addGroupFilter(kgridData, gridFilterModel, fieldAndColumns) {
        var localizedMessages = kgridData.options.messages.filter;
        var groupFilter = self.MapFilterRow({
            griddata: kgridData, row: { field: "___group___" }, types: fieldAndColumns.fields,
            filters: ["___group___"], conditions: self.conditionsDropDown(gridFilterModel.filters.length, localizedMessages)
        }, fieldAndColumns.columns);

        groupFilter.isFirst = gridFilterModel.filters.length < 1;
        groupFilter.Initialized = false;
        groupFilter.conditionDropDown = groupFilter.isFirst ? localizedMessages.where : localizedMessages.and;
        groupFilter.additionalType = "group";
        groupFilter.IsPeriodic = false;
        gridFilterModel.filters.push(groupFilter);
        var defaultFilter = self.AddDefaultFilterToGroup(kgridData, gridFilterModel, fieldAndColumns);
        if (defaultFilter) gridFilterModel.filters.push(defaultFilter);
        return groupFilter;
    };
    function backwardComp(options, cols) {
        return options;
    };

    // localization related functions
    function prepareOperatorLocalization(xoperator) {
        if (_.isArray(xoperator))
            xoperator.forEach(function (xi) {
                if (!xi.value) return;
                self.LocalizeKeys[`Operators.${xi.value}`] = xi.name;
            });
    }
    function prepareLocalizationKeys() {
        var startKey = self.LocalizePreffix;
        for (var i in XPortal.FilterCommon)
            self.LocalizeKeys[i] = XPortal.FilterCommon[i];
        for (var i in localizedMessages)
            self.LocalizeKeys[i] = localizedMessages[i];

        for (var i in self.Operators) {
            var xoperator = self.Operators[i];
            prepareOperatorLocalization(xoperator, i + '.');
        }
        prepareOperatorLocalization(self.AdditionalGridOperators, "AdditionalGridOperators.");
        return true;
    };
    function ensureLocalization() {
        if (!self._localizationPromise) {
            prepareLocalizationKeys();
            self._localizationPromise = XPortal.Localization.EnsureLocalizedTexts(self.LocalizePreffix, self.LocalizeKeys)
                .then(function (result) {
                    self.LocalizationResult = result;
                    self.Localize();
                    return result;
                })
                .catch(function (error) {
                    self._localizationPromise = null;
                    throw error;
                });
        }

        return self._localizationPromise;
    };
    function bindFilterArea(area, gridFilterModel) {
        var $area = area ? $(area) : null;
        if (!$area || !$area.length) return;
        $area.each(function () {
            var $one = $(this);
            if (!$one.is(":visible")) {
                $one.data("xpPendingFilterModel", gridFilterModel);
                return;
            }
            $one.removeData("xpPendingFilterModel");
            kendo.unbind($one);
            kendo.bind($one, gridFilterModel);
        });
    };
    function ensureFilterAreaBound(area) {
        var $area = area ? $(area) : null;
        if (!$area || !$area.length) return;
        $area.each(function () {
            var $one = $(this);
            var pendingModel = $one.data("xpPendingFilterModel");
            if (!pendingModel) return;
            $one.removeData("xpPendingFilterModel");
            kendo.unbind($one);
            kendo.bind($one, pendingModel);
        });
    };
    return self;
}());